import React from 'react';
import TrailBlazerWinners2024 from 'views/TrailBlazerWinners2024';


const TheNPSFamilyPage = () => {
  return <TrailBlazerWinners2024/>;
};

export default TheNPSFamilyPage;